<template>
  <div class="container">
    <div class="header" id="content">
      <van-nav-bar :title="$t('recharge.title')">
        <template #left>
          <van-icon name="arrow-left" color="#fff" size="20" @click="back()"></van-icon>
        </template>
      </van-nav-bar>
      <div class="info">
        <div class="avatar">
          <van-image round class="user_img" :src="userInfo.header_img">
            <template v-slot:error>
              <van-image src="img/nan/11.png"></van-image>
            </template>
          </van-image>
        </div>
        <div class="div">
          <div class="name">{{ userInfo.username }}</div>
          <div class="points">{{ $t('recharge.label') }}：{{ changeMoney(userInfo.money) }}</div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="card">
        <div class="icon">
          <img src="img/mine/kefu_avatar.png">
        </div>
        <div class="label">{{ $t('recharge.info') }}</div>
      </div>
      <div class="button" @click="toKefu">{{ $t('recharge.button') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {}
    };
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t('video.account_out'));
            localStorage.clear();
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    toKefu() {
      window.open(this.$store.getters.getBaseInfo.kefu);
    }
  }
};
</script>

<style lang='less' scoped>
@import '~@/assets/css/theme.less';

.container {
  min-height: 100%;
  background: @bg-page;
}

.header /deep/ .van-nav-bar__title {
  font-size: 1rem !important;
  line-height: 2.88rem;
}

.header /deep/ .van-nav-bar {
  background: transparent !important;
  height: 2.88rem;

  /deep/ .van-nav-bar__title {
    color: #fff;
  }
  /deep/ .van-nav-bar__left {
    padding: 0 1rem;
  }
}

.header {
  height: 9.2rem;
  background: @grad-primary;
  .info {
    display: flex;
    align-items: center;
    margin-top: 0.85rem;
    padding: 0 1.25rem;
    .avatar {
      flex-shrink: 0;
      border: 0.18rem solid rgba(255, 255, 255, 0.9);
      background: #fff;
      border-radius: 50%;
      height: 3.4rem;
      width: 3.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0.85rem;
      overflow: hidden;
      .van-image {
        width: 3.05rem;
        height: 3.05rem;
      }
    }
    .div {
      min-width: 0;
    }
    .name {
      font-size: 1.12rem;
      font-weight: 700;
      color: #fff;
      line-height: 1.35;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .points {
      margin-top: 0.2rem;
      font-size: 0.84rem;
      color: rgba(255, 255, 255, 0.92);
      line-height: 1.35;
    }
  }
}

.content {
  position: relative;
  margin-top: -1.6rem;
  padding: 0 1rem 1.6rem;
  .card {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1.05rem 1rem;
    background: #fff;
    border-radius: 1.2rem;
    box-shadow: @shadow-soft;
  }
  .icon {
    flex-shrink: 0;
    width: 3.1rem;
    height: 3.1rem;
    border-radius: 50%;
    background: linear-gradient(160deg, #fff0f6 0%, #f3ecff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img {
      width: 2.15rem;
      height: 2.15rem;
      object-fit: contain;
    }
  }
  .label {
    flex: 1;
    min-width: 0;
    font-size: 0.88rem;
    line-height: 1.55;
    color: @text-body;
  }
  .button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: max-content;
    max-width: 100%;
    box-sizing: border-box;
    margin-top: 1.15rem;
    padding: 0.75rem 1.6rem;
    min-height: 2.85rem;
    line-height: 1.3;
    white-space: nowrap;
    color: #fff;
    font-size: 0.98rem;
    font-weight: 600;
    border-radius: @radius-pill;
    background: @grad-primary;
    box-shadow: @shadow-pink;
  }
}
</style>
